import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/Auth";
import Layout from "@/components/Layout";
import { Landing, Login, Apply } from "@/pages/Public";
import { MemberHome, Profile, Account, Notifications, Help } from "@/pages/Member";
import { Investments, BorrowerLoans, Invite } from "@/pages/Member2";
import { Groups, GroupDetail } from "@/pages/Village";
import { Overview, Applications, Borrowers, BorrowerDetail } from "@/pages/Staff";
import { Users, Customers } from "@/pages/PeopleChecks";
import { Loans, LoanDetail, Reconciliation, Withdrawals } from "@/pages/Staff2";
import { Capital, Approvals, StaffGroups, Reports, Audit } from "@/pages/Staff3";
import SettingsPage from "@/pages/SettingsFriendly";
import Glossary from "@/pages/Glossary";
import Payments from "@/pages/Payments";
import Referrals from "@/pages/Referrals";
import GroupTermsPage from "@/pages/GroupTermsPage";
import ChangePassword from "@/pages/ChangePassword";
import GuidesPublic, { GuidesInApp } from "@/pages/Guides";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/invite/:token" element={<Invite />} />
          <Route path="/groups/:gid/terms" element={<GroupTermsPage />} />
          <Route path="/guides" element={<GuidesPublic />} />
          <Route path="/app" element={<Layout />}>
            <Route index element={<MemberHome />} />
            <Route path="profile" element={<Profile />} />
            <Route path="account" element={<Account />} />
            <Route path="investments" element={<Investments />} />
            <Route path="loans" element={<BorrowerLoans />} />
            <Route path="groups" element={<Groups />} />
            <Route path="groups/:id" element={<GroupDetail />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="help" element={<Help />} />
            <Route path="glossary" element={<Glossary />} />
            <Route path="guides" element={<GuidesInApp />} />
            <Route path="password" element={<ChangePassword />} />
          </Route>
          <Route path="/staff" element={<Layout staff />}>
            <Route index element={<Overview />} />
            <Route path="applications" element={<Applications />} />
            <Route path="users" element={<Users />} />
            <Route path="customers" element={<Customers />} />
            <Route path="borrowers" element={<Borrowers />} />
            <Route path="borrowers/:id" element={<BorrowerDetail />} />
            <Route path="loans" element={<Loans />} />
            <Route path="loans/:id" element={<LoanDetail />} />
            <Route path="reconciliation" element={<Reconciliation />} />
            <Route path="payments" element={<Payments />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="password" element={<ChangePassword />} />
            <Route path="withdrawals" element={<Withdrawals />} />
            <Route path="capital" element={<Capital />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="groups" element={<StaffGroups />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="audit" element={<Audit />} />
            <Route path="glossary" element={<Glossary />} />
            <Route path="guides" element={<GuidesInApp />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
